import API from '../Services/API';
import Model from './Model';

const useOnboardingJourney = (alwaysRefresh, block = false) => {
    return Model({
        block,
        alwaysRefresh,
        returnDataKey: 'journey',
        stateKey: 'onboarding',
        fetchData: () => API.get('/onboarding/journey'),
        registerAdditionalMethods: (opts) => {
            return {
                markStepDone: (stepKey) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/steps/${stepKey}/done/`),
                        null,
                        true,
                    );
                },
                markStepSkipped: (stepKey) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/steps/${stepKey}/skip/`),
                        null,
                        true,
                    );
                },
                markVideoAsPlayed: (videoId) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/videos/${videoId}/played`),
                        null,
                        true,
                    );
                },
                markVideoAsUnplayed: (videoId) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/videos/${videoId}/unplayed`),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading the onboarding journey.',
    });
}

export {
    useOnboardingJourney,
}
